import { actionCreatorFactory } from 'typescript-fsa';
import { ORDER_PARTS } from '@app/react/const/variables';

const actionCreator = actionCreatorFactory();

export const showOrderPartsHelpAction = actionCreator<{
    partsName: typeof ORDER_PARTS[number] | null }>('showOrderPartsHelpAction');
